import { useSelector } from "react-redux";
import { useFragment, useLazyLoadQuery } from "react-relay";
import { useNavigate } from "react-router-dom";
import { NavbarItem } from "@components/navbar-item";
import { useWindowSize } from "@hooks/use-window-size";
import { navbar_AuthViewerSchemaFragment$key } from "@relay/navbar_AuthViewerSchemaFragment.graphql";
import { navbar_Query } from "@relay/navbar_Query.graphql";
import { Path } from "@router/paths";
import { selectIsAvgsClient, selectPotentialAnalysisId } from "@slices/auth/auth.selectors";
import { AUTH_VIEWER_SCHEMA_FRAGMENT, QUERY } from "./navbar.graphql";
import { NavbarSkeleton } from "./navbar.skeleton";
import { CenterWrapper, StyledLogo, Wrapper } from "./navbar.styles";
import { AvatarWithProfileMenu } from "../avatar-with-profile-menu";
import { withSuspense } from "../with-suspense/with-suspense.component";

// TODO: add-translations
export const NavbarComponent = () => {
	const query = useLazyLoadQuery<navbar_Query>(QUERY, {}, { fetchPolicy: "store-or-network" });
	const isAvgsClient = useSelector(selectIsAvgsClient);
	const potentialAnalysisId = useSelector(selectPotentialAnalysisId);

	const auth = useFragment<navbar_AuthViewerSchemaFragment$key>(
		AUTH_VIEWER_SCHEMA_FRAGMENT,
		query.Viewer.Auth,
	);

	const { isXLargeUp } = useWindowSize();

	const navigate = useNavigate();

	const handleLogoOnClick = () => {
		navigate(Path.dashboard.path);
	};

	const PotentialAnalysisItem = () => {
		if (isAvgsClient || !potentialAnalysisId) return null;
		return (
			<NavbarItem
				iconName="potentialAnalysis"
				label="Potentialanalyse"
				path={Path.potentialAnalysis.withId(potentialAnalysisId).path}
			/>
		);
	};

	return (
		<Wrapper id="navbar">
			<StyledLogo onClick={handleLogoOnClick} />
			<CenterWrapper>
				<NavbarItem iconName="rewardStars" label="Zukunftstrends" path={Path.trends.path} />
				{PotentialAnalysisItem()}
				<NavbarItem
					iconName="book"
					label="Weiterentwicklung"
					path={Path.progression.path}
				/>
				{!isXLargeUp && <AvatarWithProfileMenu authViewerSchemaFragmentRef={auth} />}
			</CenterWrapper>
			{isXLargeUp && <AvatarWithProfileMenu authViewerSchemaFragmentRef={auth} />}
		</Wrapper>
	);
};

export const Navbar = withSuspense(NavbarComponent, NavbarSkeleton);
